require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/core-js/library/fn/object/get-prototype-of.js
// module id = 852
// module chunks = 0